import { getStripCalendarHeight } from '../../../pages/MyBlockMonth/myBlockMonthHelper';
import '../StripCalendar.scss';

const StripCalendarSelectedEventBorderBottom = ({selectedFields, stripCalHeightLevel}) => {  
    return (
        <div className="c-strip-calendar-event">
            <div className="event--selected-border-bottom" 
                 style={{
                    marginLeft: selectedFields.borderBottomMarginLeft ,width: selectedFields.borderBottomWidth,
                    marginTop: `${getStripCalendarHeight(stripCalHeightLevel) - 0.3}rem`
                 }}
            />
        </div>
    )
}

export default StripCalendarSelectedEventBorderBottom;